import React from 'react';

import PropTypes from 'prop-types';

import './AlertMessage.scss';

/**
 * @enum {String} Alert Message Type
 */
export const AlertStyle = {
  ALERT_SUCCESS: 'alert-success',
  ALERT_INFO: 'alert-info',
  ALERT_DANGER: 'alert-danger',
  ALERT_WARNING: 'alert-warning',
};

function AlertMessage({alertShow, alertText, alertStyle, onClick}) {
  const alert = `alert ${alertStyle} alertMessageBox`;
  let id = 0;
  if (!alertShow) return null;
  return (
    <div
      className="package"
      onClick={onClick}
    >
      <div className="alertBorder" />
      <div className="alertMessageRow">
        <div className={alert}>
          <div className="col-md-2 iconColumn">
            {alertStyle === AlertStyle.ALERT_SUCCESS && <span className="glyphicon glyphicon-ok-sign alertIcon" />}
            {alertStyle === AlertStyle.ALERT_WARNING && <span className="glyphicon glyphicon-warning-sign alertIcon" />}
            {alertStyle === AlertStyle.ALERT_INFO && <span className="glyphicon glyphicon-info-sign alertIcon" />}
            {alertStyle === AlertStyle.ALERT_DANGER && <span className="glyphicon glyphicon-remove-sign alertIcon" />}
          </div>
          <div className="col-md-10 col-lg-12 alertText">
            <strong>
              {typeof alertText === 'string' && alertText.length
                ? alertText.split('\n').map((item) => {
                    id += 1;
                    return (
                      <span key={id}>
                        {item}
                        <br />
                      </span>
                    );
                  })
                : null}
            </strong>
          </div>
          {/* <div className = "col-md-1 alertText"> 
                    <a id = "close" href="#" className="close alertIcon" data-dismiss="alert" aria-label="close" onClick = {this.onClick}>x&nbsp;</a> 
                    </div> */}
        </div>
      </div>
    </div>
  );
}

AlertMessage.propTypes = {
  alertShow: PropTypes.bool,
  onClick: PropTypes.func,
  alertText: PropTypes.string,
  alertStyle: PropTypes.oneOf(Object.values(AlertStyle)),
};

AlertMessage.defaultProps = {
  alertShow: false,
  alertText: '',
  onClick: () => {},
  alertStyle: '',
};

export default AlertMessage;
